'use strict';
// 19.1.3.6 Object.prototype.toString()
var classof = require('./_classof')
  , test    = {};
test[require('./_wks')('toStringTag')] = 'z';
if(test + '' != '[object z]'){
  require('./_redefine')(Object.prototype, 'toString', function toString(){
    return '[object ' + classof(this) + ']';
  }, true);
}


//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201706012359-95877d6b9a-master/~/core-js/modules/es6.object.to-string.js
// module id = 705
// module chunks = 1